<template>
  <div
    class="hcl-modal-favorites"
    v-if="modalIsOpen"
  >
    <div
      class="modal fade show d-block"
      aria-modal="true"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ props.title }}</h4>
            <div class="modal-buttons">
              <button
                class="btn btn-link"
                type="button"
                @click="onChoiceCancel"
              >
                <i
                  aria-hidden="true"
                  class="eii--fa6-solid--xmark"
                ></i>
              </button>
            </div>
          </div>
          <div class="modal-body">
            <div>
              <input
                type="text"
                class="form-control"
                name="favouriteName"
                id="favouriteName"
                v-model="favoritName"
              >
            </div>
          </div>
          <div class="modal-footer">
            <button
              v-if="props.buttonDeleteText"
              type="button"
              id="modal-favorite-button-delete"
              class="btn btn-primary"
              @click="onChoiceDelete"
            >
              {{ props.buttonDeleteText }}
            </button>
            <button
              type="button"
              id="modal-favorite-button-cancel"
              class="btn btn-outline-default"
              @click="onChoiceCancel"
            >
              {{ props.buttonCancelText }}
            </button>
            <button
              v-if="props.buttonSaveText"
              type="button"
              id="modal-favorite-button-save"
              class="btn btn-primary"
              @click="onChoiceSave"
            >
              {{ props.buttonSaveText }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal-backdrop fade show modal-stack"
      style="z-index: 1039"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

import { EventModalFavorites } from '@/components/types'

interface Props {
  /**
   * Should modal be open on mount?
   */
  open?: boolean
  /**
   * Title of the modal (shown in card header)
   */
  title?: string
  /**
   * Text of the 'Delete' Button
   */
  buttonDeleteText?: string
  /**
   * Text of the 'Cancel' Button
   */
  buttonCancelText?: string
  /**
   * Text of the 'Save' Button
   */
  buttonSaveText?: string
  /**
   * Favorit Type
   */
  favoritName?: string
}

const props = withDefaults(defineProps<Props>(), {
  open: false,
  title: '',
  buttonDeleteText: '',
  buttonCancelText: '',
  buttonSaveText: ''
})

const emit = defineEmits(['modal-favorites-choice'])

const modalIsOpen = ref(props.open)
const favoritName = ref(props.favoritName)

watch(
  () => props.open,
  (n) => {
    modalIsOpen.value = n
  }
)

watch(
  () => props.favoritName,
  (n) => {
    favoritName.value = n
  }
)

const onChoiceDelete = () => {
  emit(
    'modal-favorites-choice',
    { choice: 'delete' } as EventModalFavorites
  )
}

const onChoiceCancel = () => {
  emit(
    'modal-favorites-choice',
    { choice: 'cancel', value: '' } as EventModalFavorites
  )
}

const onChoiceSave = () => {
  emit(
    'modal-favorites-choice',
    { choice: 'save', value: favoritName.value } as EventModalFavorites
  )
}
</script>
